import Hottc from "../pages/hottc/index.vue"; //热门题材推荐
import HottcDetail from "../pages/hottc/detail.vue"; //热门题材详情
import HottcHistory from "../pages/hottc/history.vue"; //热门题材灵感记录
import HottcResutl from "../pages/hottc/result.vue"; //生成灵感
const routes = [
  {
    path: "/hottc",
    name: "hottc",
    component: Hottc,
  },
  {
    path: "/hottc_detail",
    name: "hottc_detail",
    component: HottcDetail,
  },
  {
    path: "/hottc_history",
    name: "hottc_history",
    component: HottcHistory,
  },
  {
    path: "/hottc_result",
    name: "hottc_result",
    component: HottcResutl,
  },
];
export default routes;
